import { Component } from '@angular/core';
import { intToTime } from '../../../helpers/formatNumbers';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-bar-avg-duration',
  templateUrl: './bar-avg-duration.component.html',
  styleUrl: './bar-avg-duration.component.scss',
})
export class BarAvgDurationComponent {
  isLoading = true;

  formatFunction = intToTime;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.barAvgDuration$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('barAvgDuration');
    });

    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getBarAvgDuration().subscribe();
  }

  get data() {
    return this.analyticsService.barAvgDuration$.value;
  }
}
